import { Modal } from 'ui'

import style from './ModalDownload.module.scss'

type ModalDownloadProps = {
  open: boolean
  onClose: () => void
}

export function ModalDownload({ open, onClose }: ModalDownloadProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className={style.modal}>
        <span className={style.title}>Установка бесплатного приложения</span>

        <span className={style.subtitle}>
          Вы можете загрузить полностью бесплатное приложение «Мой DoorHan» в
          магазинах приложений Гугл Плей (Google Play), Эпп Стор (App Store) или
          РуСтор (RuStore).
        </span>

        <div className={style.links}>
          <a
            href='https://play.google.com/store/apps/details?id=com.doorhan.automations&hl=ru'
            target='_blank'
            rel='noreferrer'
            className={style.link}
          >
            <img
              src='/images/pages/download/google-play.svg'
              alt='Google Play'
              className={style.image}
            />
          </a>
          <a
            href='https://www.rustore.ru/catalog/app/com.doorhan.automations'
            target='_blank'
            rel='noreferrer'
            className={style.link}
          >
            <img
              src='/images/pages/download/rustore.svg'
              alt='Rustore'
              className={style.image}
            />
          </a>

          <a
            href='https://apps.apple.com/us/app/mydoorhan/id6463870110'
            target='_blank'
            rel='noreferrer'
            className={style.link}
          >
            <img
              src='/images/pages/download/appstore.svg'
              alt='appstore'
              className={style.image}
            />
          </a>
        </div>
      </div>
    </Modal>
  )
}
